<template lang="">
  <div>
    <div class="userinfoForm" v-loading="loading">
      <el-form ref="pswForm" :model="pswForm" label-width="80px" size="small">
        <el-form-item label="旧密码" prop="passwd" :rules="{ required: true, message: '必填', trigger: 'blur' }">
          <el-input type="password" v-model="pswForm.passwd" placeholder="请输入当前登录的密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="passwdNew" :rules="{ required: true, validator: validatePsw, trigger: 'blur' }">
          <el-input type="password" v-model="pswForm.passwdNew" placeholder="登录密码，由数字、字母（8-16位）组成"></el-input>
        </el-form-item>
        <el-form-item label="再次输入" prop="passwdNew2" :rules="{ required: true, validator: validatePsw2, trigger: 'blur' }">
          <el-input type="password" v-model="pswForm.passwdNew2" placeholder="再次输入一遍新密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('pswForm')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  import * as API from '@/api/main'
export default {
  data(){
    return {
      imgBase:this.$store.state.imgBaseUrl,//图片前缀
      loading:false,
      pswForm:{
        
      },
    }
  },
  methods: {

    //校验密码
    validatePsw(rule, value, callback) {
      let pswReg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/; //有数字、密码，8-16位
      if (!value) {
        return callback(new Error('请输入密码')) ;
      }
      setTimeout(() => {
        if (!pswReg.test(value) && value.indexOf("*")==-1) {
          callback(new Error('由数字、字母（8-16位）组成'));
        } else {
          callback();
        }
      }, 0)
    },
    
    //重复
    validatePsw2(rule, value, callback) {
      // let pswReg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/; //有数字、密码，8-16位
      if (!value) {
        return callback(new Error('请再次输入密码')) ;
      }
      setTimeout(() => {
        if (value===this.pswForm.passwdNew) {
          callback();
        } else {          
          callback(new Error('两次密码输入不一致'));
        }
      }, 0)
    },

    //提交修改
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {          
            API.UpdatePassword(this.pswForm).then(res=>{
              this.$message({
                message: res.info,
                type: 'success'
              });           
              this.resetForm(formName);
            })
        } else {
          return false;
        }
      });
    },

    //重置校验
    resetForm(formName) {
        this.$refs[formName].resetFields();
    },

  },
  created() {
    
  },
}
</script>
<style scoped>
  .userinfoForm{width:500px;margin-left:50px;}
  @media screen and (max-width: 1200px) {
    .userinfoForm{width:100%;margin-left:0;}
  }
</style>